import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./JMFinancials.css";
import vdo1 from "../../../vedios/JM Financial - A journey of 50 years.mp4";
import vdo2 from "../../../vedios/JM Financial Ltd. FY 2022 - 23 Highlights.mp4";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Values() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/JM-Financial",
      "jmf_about-us_jm-financial",
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "JMFinancials Page Loaded",
      label: "jmf_about-us_jm-financial",
      // value: 1,
    });
  }, []);

  return (
    <>
      <section>
        <Container>
          <div className="vision-main">
            <div className="section-header">
              <h2>JM Financial</h2>
            </div>
            {/* <Row>
              <Col sm={12} md={12}>
                <div className="vision-data">
                  <h6>
                    <b>
                      Celebrating 50 Glorious Years of Excellence – JM Financial{" "}
                    </b>
                  </h6>
                  <p>
                    The incredible journey of one of India’s prominent
                    integrated financial services groups built on strong
                    fundamentals and sustainable values, has reached a glorious
                    milestone. In 2023, JM Financial Group celebrates 50
                    remarkable years since its inception in 1973. Our enduring
                    legacy, a testament to unwavering commitment to core values
                    and strong leadership, spans half a century.The
                    50-year-milestone is made of many significant achievements
                    and those are the building blocks of JM Financial of today.
                    The Group takes pride in the landmark achieved and is geared
                    up to redefine the future growth by deriving strength from
                    superior insights and learning apart from focussing on
                    innovation and stronger client-engagement{" "}
                  </p>
                  <div className="iap-download">
                    <a target="_balnk" href={vdo1}>
                      JM Financial Ltd: 50 Years Visual Journey
                    </a>
                  </div> */}
            {/* <p>
                                    The next phase of the exciting journey begins from here
                                </p> */}
            {/* <div className='mp4-vdo'>
                                    <div>
                                        <video width="350" height="300" controls >
                                            <source src={vdo1} type="video/mp4" />
                                        </video>
                                    </div>
                                    <div>
                                        <video width="350" height="300" controls >
                                            <source src={vdo2} type="video/mp4" />
                                        </video>
                                    </div>
                                </div> */}
            {/* </div> */}
            {/* </Col>
            </Row> */}
            <div className="vision-detail">
              <Row>
                {/*  <Col sm={12} md={6}>
                                            <div className='vision-img'>
                                                { <img src={AboutusVision} alt='vision-banner' className='img-fluid'></img> }
                                            </div>
                                        </Col> */}
                <Col sm={12} md={12}>
                  <div className="vision-data">
                    <h3>
                      <strong>Company Profile</strong>
                    </h3>
                    {/* <p>
                      JM Financial, one of India’s prominent integrated
                      financial services group, offers an array of services to
                      corporations, financial institutions, high net-worth
                      individuals and retail.
                    </p> */}
                    <p>
                      JM Financial is an integrated and diversified financial
                      services group. The Group’s primary businesses include
                      <span style={{ fontWeight: "bold" }}>
                        (i) Corporate Advisory and Capital Markets
                      </span>{" "}
                      caters to Institutional, Corporate, Promoters, Government
                      and Ultra High Networth clients and includes investment
                      banking, and institutional equities and research;{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        (ii) Wealth and Asset Management{" "}
                      </span>
                      includes wealth management business, broking, PMS, Equity &
                      Debt AIFs, and mutual fund business;{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        (iii) Private Markets
                      </span>
                      comprises of Private Credit (Corporate, Bespoke, Real
                      Estate and Distressed Credit) and Investments (Private
                      equity funds, REITs etc.); and {" "}
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        (iv) Affordable Home Loans
                      </span>{" "}
                      includes the affordable housing finance business.
                    </p>
                    <p>
                     Over the years, JM Financial has partnered with several leading Indian and 
International clients and earned their trust and confidence. JM Financial has 
pioneered several strategies and transactions for a wide client base spread across 
geographies and thus developed rich experience and expertise. Every idea is unique 
to the need of the client and supported by superior and timely execution to deliver 
maximum benefits.  
                    </p>
                    <p>
                   As of December 31, 2025, the consolidated loan AUM stood at ~Rs. 97.6 BN, distressed 
credit business AUM at ~Rs. 127.2 BN, wealth management AUM at ~Rs. 1.16 TN and 
mutual fund AAUM at ~Rs. 143.4 BN. 
                    </p>
                    <p>
                     The Group is headquartered in Mumbai and has a presence across 938 locations 
spread across 230 cities in India. The equity shares of JM Financial Limited are listed in 
India on the BSE and NSE.
                    </p>
                    <p>
                      A people-focused organisation, JM Financial has a rich mix of professionals from 
diverse backgrounds who bring varied talents, knowledge and experiences to the 
workplace, thereby helping businesses to grow to the next level.
                    </p>
                    <p>
                    The Group has to its credit several national and international accolades for its insightful 
advice and execution skills.
                    </p>
                    <p>
                    JM Financial Group is deeply committed to investing in initiatives that improve and 
foster communities enabling them to sustain themselves. The Group, along with its 
employees, actively supports various causes related to education, healthcare, skill 
development, entrepreneurship promotion, disaster relief and animal welfare.
                    </p>
                    <p>
                      For more information, please do visit{" "}
                      <a target="_blank" href="https://jmfl.com/">
                        www.jmfl.com
                      </a>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Values;
